let prodSample = [];
let svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM9.99998 16L9.46965 16.5304C9.76255 16.8232 10.2374 16.8232 10.5303 16.5303L9.99998 16ZM7.53027 12.4697C7.23737 12.1768 6.7625 12.1768 6.46961 12.4697C6.17671 12.7626 6.17672 13.2374 6.46961 13.5303L7.53027 12.4697ZM16.4697 8.46967L9.46965 15.4697L10.5303 16.5303L17.5303 9.53033L16.4697 8.46967ZM6.46961 13.5303L9.46965 16.5304L10.5303 15.4697L7.53027 12.4697L6.46961 13.5303Z"></path></svg>`;
let handle = 'promoPage';
let currentCursor = '';
let currentNext
let pageCount = 0;
let checking = false;
let freshLoad = true;
let listening = false;
let bestSellers = true;
let vehicleSearch = false;
let sizePage = false;
let sortKey = 'BEST_SELLING'
let sortDescending = false;
let pageSize = 24;
let loop = false;
let firstLoop = true;
let prodClasses
let failCount = 0;
let promoDeselected = false;
let promoFilters;
localStorage.setItem('lastPLP', window.location.href);

async function dualGrid() {
    checking = false;
    document.querySelector('.loading-overlay').style.display = 'block';
    pageSize = 50;
    let params = [];
    let newParams;
    let varparams;
    let priceparams;
    if (freshLoad) {
        let filt = await filterGrab();
        for (let i = 0; i < filt[0].values.length; i++) {
            let filtInput = JSON.parse(filt[0].values[i].input);
            params.push([`filter.v.m.${filtInput.variantMetafield.namespace}.${filtInput.variantMetafield.key}`,filtInput.variantMetafield.value]);
        }
    } else {
        params = Array.from(new FormData(document.getElementById('FacetsFilterForm')));
        if (window.location.search.includes('filter')) {
            let urlFilters = Array.from(new URLSearchParams(window.location.search));
            for (i = urlFilters.length; i--;) {
                if (!urlFilters[i][0].includes('filter') && !urlFilters[i][0].includes('sort_by')) {
                    urlFilters.splice(i, 1)
                }
            }
            history.replaceState(null, '', window.location.pathname)
            params = urlFilters;
        }
    }
    if (params.filter(param => param[0] == 'sort_by').length > 0) {
        if (params.filter(param => param[0] == 'sort_by')[0][1].toUpperCase().includes('BEST')) {
            sortKey = 'BEST_SELLING';
        } else {
            let sort = params.filter(param => param[0] == 'sort_by')[0][1].split('-');
            if (sort[1] == 'descending') {
                sortDescending = true;
            } else {
                sortDescending = false;
            }
            sortKey = sort[0].toUpperCase();
        }
    }
    if (typeof params[0] == 'string') {
        let paramFix = [];
        for (let i = 0; i < params.length; i++) {
            let paramArray = [];
            paramArray.push(params[i]);
            i++
            paramArray.push(params[i]);
            paramFix.push(paramArray);
        }
        params = paramFix;
    }
    newParams = [];
    for (i = 0; i < params.length; i++) {
        let idx
        idx = newParams.find(param => param && param.paramName == params[i][0]);
        idx = newParams.indexOf(idx);
        if (idx >= 0) {
            newParams[idx].paramValue.push(params[i][1]);
        } else {
            newParams.push({
                paramName: params[i][0],
                paramValue: [
                    params[i][1]
                ]
            })
        }
    }
    varparams = newParams.filter(par => par.paramName.includes('filter.v.m'));
    if (varparams.find(param => param.paramName.includes('run_flat'))) {
        if (varparams[varparams.indexOf(varparams.find(param => param.paramName.includes('run_flat')))].paramValue[0] == 0) {
            varparams[varparams.indexOf(varparams.find(param => param.paramName.includes('run_flat')))].paramValue = ['false'];
        } else {
            varparams[varparams.indexOf(varparams.find(param => param.paramName.includes('run_flat')))].paramValue = ['true'];
        }
    }
    priceparams = params.filter(par => par[0].includes('price'));
    let filters = ''
    let metaFilters = ''
    for (i = 0; i < varparams.length; i++) {
        for (j = 0; j < varparams[i].paramValue.length; j++) {
            if (j == 80) {
                break;
            }
            if (filters.length > 0) {
                filters = `${filters},{variantMetafield:{namespace:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[0]}",key:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[1]}",value:"${varparams[i].paramValue[j]}"}}`;
            } else {
                filters = `{variantMetafield:{namespace:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[0]}",key:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[1]}",value:"${varparams[i].paramValue[j]}"}}`;
            }
        }

        if (varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[1] == "promotion_secondary_text") {
            continue;
        }
        if (filters.length > 0) {
            metaFilters = `${metaFilters},{namespace:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[0]}",key:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[1]}"}`;
        } else {
            metaFilters = `{namespace:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[0]}",key:"${varparams[i].paramName.replaceAll('filter.v.m.', '').split('.')[1]}"}`;
        };
    }
    if (metaFilters.length > 0) {
        metaFilters = `${metaFilters},{namespace:"display",key:"promotion_secondary_text"},{namespace:"storefront_icons",key:"left"},{namespace:"storefront_icons",key:"right"}`;
    } else {
        metaFilters = `{namespace:"display",key:"promotion_secondary_text"},{namespace:"storefront_icons",key:"left"},{namespace:"storefront_icons",key:"right"}`;
    }
    let pageFilters = '';
    if (filters.length > 0) {
        pageFilters = filters;
    }
    let pagevendorFilters = params.filter(par => par[0] == 'filter.p.vendor');
    if (pagevendorFilters.length > 0) {
        let pageVendors = '';
        for (i = 0; i < pagevendorFilters.length; i++) {
            if (pageVendors.length > 0) {
                pageVendors = `${pageVendors},{productVendor:"${pagevendorFilters[i][1]}"}`;
            } else {
                pageVendors = `{productVendor:"${pagevendorFilters[i][1]}"}`;
            }
        }
        pageFilters = `${pageFilters},${pageVendors}`;
    }
    if (pageFilters.length > 0) {
        pageFilters = `, filters:[${pageFilters}]`
    }
    let after = '';
    if (pageCount > 0) {
        if (currentNext) {
            after = `,after:"${currentCursor}"`
        }
    }
    let queryString = `{
	collection(handle:"promotions") {
        PageProd: products(first:${pageSize}${pageFilters},sortKey:${sortKey}${after}) {
            filters {
				id
				label
				presentation
				type
				values {
					id
					count
					label
					input
				}
			}
			edges {
				node {
                    createdAt
					title
					handle
					vendor
                    onlineStoreUrl
					images(first:2) {
						edges {
							node {
								altText
								url
							}
						}
					}
					variants(first:250) {
						edges {
							node {
								availableForSale
								id
								price {
									amount
								}
								metafields(identifiers:[${metaFilters}]) {
									namespace
									key
									value
                                    references(first:20) {
										edges {
											node {
												... on MediaImage {
													image {
														altText
														url
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
	        pageInfo {
		        hasNextPage
		        endCursor
	        }   
		}
	}
}`
    const opt = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': sFront
        },
        body: JSON.stringify({ query: queryString })
    };
    fetch(`https://${window.location.host}/api/2025-10/graphql.json`, opt)
        .then(response => {
            if (response.status > 400) {
                if (failCount == 0) {
                    let cartCookie = '';
                    if (decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart=')).length > 0) {
                        cartCookie = decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart='))[0].split('=')[1].split('?')[0];
                    }
                    let errorSubmission = {};
                    errorSubmission.url = window.location.href;
                    errorSubmission.selectedStore = localStorage.getItem('selectedStore');
                    errorSubmission.vehicleID = localStorage.getItem('currentID');
                    errorSubmission.cart = cartCookie;
                    errorSubmission.error = err;
                    const OPT = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(errorSubmission)
                    };
                }
                fetch(`${url.replace('vehicle', 'log/server_error')}?subscription-key=${key}`, OPT)
                    .then(response => {
                        currentCursor = '';
                        currentNext = false;
                        loop = false;
                        pageCount = 0;
                        pageSize = 24;
                        dualGrid();

                    })
                    .catch(err => {
                        console.error(err);
                    });
                return 'leave';
            } else {
                return response;
            }
        })
        .then(response => {
            if (response == 'leave') {
                return response;
            } else {
                return response.json();
            }
        })
        .then(response => {
            if (response == 'leave') {
                return;
            }
            if (document.getElementById('product-grid').classList.contains('collection-empty') && prodClasses) {
                let prodData = document.getElementById('product-grid').dataset;
                document.getElementById('product-grid').className = '';
                for (let i = 0; i < prodClasses.length; i++) {
                    document.getElementById('product-grid').classList.add(prodClasses[i])
                }
                document.getElementById('product-grid').dataset = prodData;
            }
            if (vehicleSearch) {
                if (localStorage.getItem('productType') == 'wheel') {
                    fitment = JSON.parse(localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`)).wheel_fitments[localStorage.getItem('currentidx')];
                } else {
                    fitment = JSON.parse(localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`)).tyre_fitments[localStorage.getItem('currentidx')];
                }
            }
            currentCursor = response.data.collection.PageProd.pageInfo.endCursor;
            currentNext = response.data.collection.PageProd.pageInfo.hasNextPage;
            let gridProds = response.data.collection.PageProd.edges;
            gridProds = gridProds.filter(prod => prod.node.variants.edges.filter(v => v.node.metafields.filter(meta => meta?.namespace == "display" && meta?.key == "promotion_secondary_text" && meta?.value.length > 0).length > 0).length > 0)
            for (q = 0; q < gridProds.length; q++) {
                //gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(v => v.node.metafields.filter(meta => meta?.namespace == "display" && meta?.key == "promotion_secondary_text" && meta?.value.length > 0).length > 0)
                /*for (z = 0; z < gridProds[q].node.variants.edges.length; z++) {
                    gridProds[q].node.variants.edges[z].node.metafields = gridProds[q].node.variants.edges[z].node.metafields.filter(meta => meta);
                }*/
                for (t = 0; t < gridProds[q].node.variants.edges.length; t++) {
                    gridProds[q].node.variants.edges[t].node.metafields = gridProds[q].node.variants.edges[t].node.metafields.filter(meta => meta != null)
                }

                for (j = 0; j < varparams.length; j++) {
                    if (params.filter(param => param[0] == 'filter.v.availability').length > 0 && params.filter(param => param[0] == 'filter.v.availability')[0][1].length > 0) {
                        if (params.filter(param => param[0] == 'filter.v.availability')[0][1] == 0) {
                            gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(variant => variant.node.metafields.filter(meta => meta && meta.namespace && meta.key && meta.value && meta.namespace == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[0] && meta.key == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[1] && varparams[j].paramValue.some(metaCheck, meta.value)).length > 0 && !variant.node.availableForSale);
                        } else {
                            gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(variant => variant.node.metafields.filter(meta => meta && meta.namespace && meta.key && meta.value && meta.namespace == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[0] && meta.key == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[1] && varparams[j].paramValue.some(metaCheck, meta.value)).length > 0 && variant.node.availableForSale);
                        }
                    } else {
                        gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(variant => variant.node.metafields.filter(meta => meta && meta.namespace && meta.key && meta.value && meta.namespace == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[0] && meta.key == varparams[j].paramName.replaceAll('filter.v.m.', '').split('.')[1] && varparams[j].paramValue.some(metaCheck, meta.value)).length > 0);
                    }
                }
                gridProds[q].node.variants.edges.sort((a, b) => a.node.price.amount - b.node.price.amount);
                if (priceparams.length > 0) {
                    if (priceparams[0][1].length > 0 || priceparams[1][1].length > 0) {
                        for (z = 0; z < priceparams.length; z++) {
                            if (priceparams[z][0].includes('.gte') && priceparams[z][1].length > 0) {
                                gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(variant => Number(variant.node.price.amount) >= Number(priceparams[z][1]))
                            }
                            if (priceparams[z][0].includes('.lte') && priceparams[z][1].length > 0) {
                                gridProds[q].node.variants.edges = gridProds[q].node.variants.edges.filter(variant => Number(variant.node.price.amount) <= Number(priceparams[z][1]))
                            }
                        }
                    }
                }
            }
            gridProds = gridProds.filter(prod => prod.node.variants.edges.length > 0);
            if (gridProds.length == 0 && currentNext) {
                pageCount = pageCount + 1;
                loop = true;
                dualGrid();
                return;
            }
            if (sortKey == 'CREATED') {
                if (sortDescending) {
                    gridProds.sort((a, b) => Date.parse(b.node.createdAt) - Date.parse(a.node.createdAt));
                } else {
                    gridProds.sort((a, b) => Date.parse(a.node.createdAt) - Date.parse(b.node.createdAt));
                }
            } else if (sortKey == 'TITLE') {
                if (sortDescending) {
                    gridProds.sort((a, b) => b.node.title.localeCompare(a.node.title));
                } else {
                    gridProds.sort((a, b) => a.node.title.localeCompare(b.node.title));
                }
            } else if (sortKey == 'PRICE') {
                gridProds.sort((a, b) => a.node.variants.edges[0].node.price.amount - b.node.variants.edges[0].node.price.amount);
            }
            for (i = 0; i < response.data.collection.PageProd.filters.length; i++) {
                if (response.data.collection.PageProd.filters.id == "filter.v.price") {
                    continue;
                }
                response.data.collection.PageProd.filters[i].values = response.data.collection.PageProd.filters[i].values.filter(value => value.count > 0);
            }
            response.data.collection.PageProd.filters = response.data.collection.PageProd.filters.filter(filters => filters.values.length > 0 || filters.id == "filter.v.price");
            let sidebar = document.createElement('div');
            sidebar.classList.add('page-layout-sidebar-inner-content');
            document.querySelector('.collection-actions-filters').innerHTML = '';
            for (i = 0; i < response.data.collection.PageProd.filters.length; i++) {
                if (response.data.collection.PageProd.filters[i].id != 'filter.v.m.tyre_spec.size_full' && response.data.collection.PageProd.filters[i].id != 'filter.v.m.wsp.sf') {
                    sidebar.appendChild(facetBuild(response.data.collection.PageProd.filters[i], i, params, priceparams, freshLoad));
                }
            }
            if (document.querySelector('.collection-actions-filters').innerHTML.length > 0) {
                let clearAll = document.createElement('clear-filters');
                let clearText = document.createElement('div');
                clearText.classList.add('button-text-link');
                clearText.textContent = 'Clear Filters';
                clearAll.appendChild(clearText);
                document.querySelector('.collection-actions-filters').appendChild(clearAll);
                document.querySelector('clear-filters').addEventListener('click', function () {
                    clearAll();
                })
            }
            document.querySelector('.page-layout-sidebar-inner-content').innerHTML = sidebar.innerHTML;
            let urlParamString = '';
            for (i = 0; i < varparams.length; i++) {
                for (j = 0; j < varparams[i].paramValue.length; j++) {
                    if (i == 0 && j == 0) {
                        urlParamString = `${varparams[i].paramName}=${varparams[i].paramValue[j]}`;
                    } else {
                        urlParamString = `${urlParamString}&${varparams[i].paramName}=${varparams[i].paramValue[j]}`;
                    }
                }
            }
            urlParamString = `?filter_params${urlParamString}endparam`;
            if (document.getElementById('collection-sort-order')) {
                if (response.data.collection.PageProd.pageInfo.hasNextPage) {
                    for (i = document.getElementById('collection-sort-order').options.length; i--;) {
                        if (document.getElementById('collection-sort-order').options[i].value.includes('PRICE')) {
                            document.getElementById('collection-sort-order').removeChild(document.getElementById('collection-sort-order').options[i])
                        }
                    }
                } else {
                    if ([...document.getElementById('collection-sort-order').options].filter(opt => opt.value.includes('PRICE-ascending')).length == 0) {
                        let ascendingPrice = document.createElement('option');
                        ascendingPrice.value = 'PRICE-ascending';
                        ascendingPrice.textContent = 'Price, low to high';
                        document.getElementById('collection-sort-order').appendChild(ascendingPrice);
                    }
                    if ([...document.getElementById('collection-sort-order').options].filter(opt => opt.value.includes('PRICE-descending')).length == 0) {
                        let descendingPrice = document.createElement('option');
                        descendingPrice.value = 'PRICE-descending';
                        descendingPrice.textContent = 'Price, high to low';
                        document.getElementById('collection-sort-order').appendChild(descendingPrice);
                    }
                }
            }
            if (pageCount == 0) {
                document.getElementById('product-grid').innerHTML = '';
            }
            if (loop && firstLoop) {
                document.getElementById('product-grid').innerHTML = '';
            }
            for (n = 0; n < gridProds.length; n++) {
                document.getElementById('product-grid').appendChild(productBuild(gridProds[n], urlParamString));
            }
            if (gridProds.length == 0 && !currentNext) {
                let prodData
                if (!document.getElementById('product-grid').classList.contains('collection-empty')) {
                    prodClasses = [...document.getElementById('product-grid').classList];
                    prodData = document.getElementById('product-grid').dataset;
                }
                document.getElementById('product-grid').outerHTML = '<div id="product-grid" class="collection collection-empty"><div class="loading-overlay"></div></div>';
                document.getElementById('product-grid').dataset = prodData;
                let head = document.createElement('h2');
                head.textContent = 'No products found';
                document.getElementById('product-grid').appendChild(head);
                if (!vehicleSearch || response.data.collection.PageProd.filters.filter(filt => filt.id != 'filter.v.m.tyre_spec.size_full' && filt.id != 'filter.v.m.wsp.sf' && filt.values.length > 0).length > 0) {
                    let para = document.createElement('p');
                    para.innerHTML = `Use fewer filters or <a href="#" class="button-text-link" id="facetClear">clear all</a>`
                    document.getElementById('product-grid').appendChild(para);
                    document.getElementById('facetClear').addEventListener('click', function () {
                        promoDeselected = false;
                        clearAll();
                    })
                }
            }
            document.querySelector('.loading-overlay').style.display = 'none';
            pageCount = pageCount + 1;
            if (!document.getElementById('tray')) {
                let tray = document.createElement('div');
                tray.classList.add('buttonTray');
                tray.id = 'tray';
                let backToTop = document.createElement('div');
                backToTop.classList.add('trayButton');
                backToTop.id = 'backToTop';
                backToTop.textContent = 'Back To Top';
                tray.appendChild(backToTop);
                document.getElementById('ProductGridContainer').appendChild(tray);
            }
            if (currentNext) {
                document.addEventListener('scroll', infiniteScroll)
            }
            if (document.getElementById('backToTop')) {
                document.getElementById('backToTop').addEventListener('click', function () {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                    });
                })
            }
            checking = false;
            if (loop) {
                firstLoop = false;
            }
            loop = false;
            checkListen();
            facetListen();
            priceListen();
            if (document.getElementById('collection-sort-order') && !listening) {
                listening = true;
                document.getElementById('collection-sort-order').addEventListener('change', function () {
                    gridTrigger(0)
                });
            }
            freshLoad = false;
        })
        .catch(err => {
            console.error(err);
            /*let cartCookie = '';
            if (decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart=')).length > 0) {
                cartCookie = decodeURIComponent(document.cookie).split(';').filter(cookie => cookie.includes('cart='))[0].split('=')[1].split('?')[0];
            }
            let errorSubmission = {};
            errorSubmission.url = window.location.href;
            errorSubmission.selectedStore = localStorage.getItem('selectedStore');
            errorSubmission.vehicleID = localStorage.getItem('currentID');
            errorSubmission.cart = cartCookie;
            errorSubmission.error = err;
            const OPT = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(errorSubmission)
            };
            fetch(`${url.replace('vehicle', 'log/server_error')}?subscription-key=${key}`, OPT)
                .then(response => {
                    currentCursor = '';
                    currentNext = false;
                    loop = false;
                    pageCount = 0;
                    pageSize = 24;
                    dualGrid();
                })
                .catch(err => {
                    console.error(err);
                });*/
        });
}

function metaCheck(paramvalues) {
    if (this.includes('[') && this.includes(']')) {
        let matches = JSON.parse(this);
        if (typeof paramvalues == 'object') {
            for (let i = 0; i < matches.length; i++) {
                if (paramvalues.includes(matches[i])) {
                    return paramvalues.includes(matches[i]);
                }
            }
        } else {
            for (let i = 0; i < matches.length; i++) {
                if (paramvalues == matches[i]) {
                    return paramvalues == matches[i];
                }
            }
        }
        return false;
    } else {
        if (typeof paramvalues == 'object') {
            return paramvalues.includes(this);
        } else {
            return paramvalues == this;
        }
    }
}

function inputGenerator(X, Y) {
    let matchInput = document.createElement('input');
    matchInput.type = 'hidden';
    matchInput.name = Y;
    matchInput.value = X;
    matchInput.checked = true;
    matchInput.classList.add('facet-filter-checkbox');
    matchInput.setAttribute('form', 'FacetsFilterForm');
    document.getElementById('FacetsFilterForm').appendChild(matchInput);
}

function clearAll() {
    let checkboxes = [...document.getElementById('FacetsFilterForm').querySelectorAll('input')].filter(input => input.type == 'checkbox' && input.checked == true);
    let numbersInputs = [...document.getElementById('FacetsFilterForm').querySelectorAll('input')].filter(input => input.type == 'number' && input.value != '');
    for (v = 0; v < checkboxes.length; v++) {
        checkboxes[v].checked = false;
    }
    for (v = 0; v < numbersInputs.length; v++) {
        numbersInputs[v].value = '';
    }
    currentCursor = '';
    currentNext = false;
    loop = false;
    pageCount = 0;
    pageSize = 24;
    dualGrid();
}

function checkListen() {
    let boxes = document.querySelectorAll('.facet-filter-checkbox')
    for (i = 0; i < boxes.length; i++) {
        boxes[i].addEventListener('change', (event) => {
            if (!checking) {
                if(event.target.id.includes('Promotions')) {
                    promoDeselected = true;
                }
                checking = true;
                gridTrigger(1500)
            }
        })
    }
}

function priceListen() {
    document.getElementById('Price-from').addEventListener('input', (event) => {
        gridTrigger(1500);
    })
    document.getElementById('Price-to').addEventListener('input', (event) => {
        gridTrigger(1500);
    })
}

function facetListen() {
    if (document.querySelectorAll('facet-remove').length > 0) {
        for (i = 0; i < document.querySelectorAll('facet-remove').length; i++) {
            document.querySelectorAll('facet-remove')[i].addEventListener('click', function (event) {
                if (event.currentTarget.dataset.facet.includes('Price')) {
                    document.getElementById(event.currentTarget.dataset.facet).value = '';
                } else {
                    document.getElementById(event.currentTarget.dataset.facet).checked = false;
                }
                gridTrigger(0);
            })
        }
    }
}

function gridTrigger(X) {
    currentCursor = '';
    currentNext = false;
    pageCount = 0;
    pageSize = 24;
    setTimeout(dualGrid, X);
}

function facetBuild(X, Y, Z, A, B) {
    let filterDiv = document.createElement('div');
    filterDiv.classList.add('js-filter');
    filterDiv.dataset.index = Y + 1;
    filterDiv.dataset.name = X.id;
    let collapse = document.createElement('collapsible-expandable');
    if (Y > 4) {
        collapse.setAttribute('expanded', 'false');
    } else {
        collapse.setAttribute('expanded', 'true');
    }
    let facet = document.createElement('div');
    facet.classList.add('facet');
    facet.dataset.index = Y + 1;
    let fToggle = document.createElement('button');
    fToggle.classList.add('facet-toggle');
    fToggle.type = 'button';
    if (Y > 4) {
        fToggle.ariaExpanded = 'false';
    } else {
        fToggle.ariaExpanded = 'true';
    }
    let fTitle = document.createElement('span');
    fTitle.textContent = X.label;
    let angle = document.createElement('span');
    angle.classList.add('angle', 'angle-down');
    let angleIco = document.createElement('span');
    angleIco.classList.add('angle-icon');
    angle.appendChild(angleIco);
    fToggle.appendChild(fTitle);
    fToggle.appendChild(angle);
    facet.appendChild(fToggle);
    let fContent = document.createElement('div');
    fContent.classList.add('facet-content');
    if (X.id == 'filter.v.price') {
        let pRange = document.createElement('price-range');
        let facetRange = document.createElement('div');
        facetRange.classList.add('facets-price-range');
        let gteRangeField = facetPrice("filter.v.price.gte", A);
        facetRange.appendChild(gteRangeField);
        let lteRangeField = facetPrice("filter.v.price.lte", A);
        facetRange.appendChild(lteRangeField);
        pRange.appendChild(facetRange);
        fContent.appendChild(pRange);
    } else {
        let ul = document.createElement('ul');
        ul.classList.add('facet-options-list');
        ul.ariaExpanded = false;
        for (q = 0; q < X.values.length; q++) {
            let li;
            let checkFacet;
            let label;
            let checkInput;
            let checkSpan;
            let spanListing;
            let spanCount;
            li = document.createElement('li');
            li.classList.add('facet-options-list-item');
            checkFacet = document.createElement('span');
            checkFacet.classList.add('checkbox-facet');
            label = document.createElement('label');
            label.classList.add('checkbox-facet-label');
            label.setAttribute('for', `filter-${X.label}-${q + 1}`);
            checkInput = document.createElement('input');
            checkInput.id = `filter-${X.label}-${q + 1}`;
            checkInput.type = 'checkbox';
            checkInput.name = X.id;
            checkInput.classList.add('facet-filter-checkbox')
            checkInput.value = X.values[q].label;
            checkInput.setAttribute('form', 'FacetsFilterForm');
            if (Z.filter(param => param[0] == X.id && param[1] == X.values[q].label).length > 0) {
                checkInput.setAttribute('checked', 'true');
                let facetRemove = document.createElement('facet-remove');
                facetRemove.dataset.facet = `filter-${X.label}-${q + 1}`;
                let facetTab = document.createElement('div');
                facetTab.classList.add('collection-filter-button', 'button', 'button-secondary');
                let facetName = document.createElement('span');
                facetName.textContent = `${X.label}: ${X.values[q].label}`;
                facetTab.appendChild(facetName);
                let facetClose = document.createElement('span');
                facetClose.classList.add('collection-filter-dismiss');
                facetClose.textContent = '×';
                facetTab.appendChild(facetClose);
                facetRemove.appendChild(facetTab);
                document.querySelector('.collection-actions-filters').appendChild(facetRemove);
            }
            if (X.label == "Promotions" && B) {
                checkInput.setAttribute('checked', 'true');
            }
            label.appendChild(checkInput);
            checkSpan = document.createElement('span');
            checkSpan.classList.add('checkbox-facet-check');
            label.appendChild(checkSpan)
            label.innerHTML = `${label.innerHTML}${svg}`;
            spanListing = document.createElement('span');
            spanListing.setAttribute('v', '0');
            spanListing.setAttribute('vf', '0');
            spanListing.classList.add('checkbox-facet-label-text');
            spanListing.textContent = X.values[q].label;
            label.appendChild(spanListing)
            if (!vehicleSearch || !currentNext) {
                spanCount = document.createElement('span');
                spanCount.classList.add('checkbox-facet-label-count');
                spanCount.textContent = X.values[q].count;
                label.appendChild(spanCount)
            }
            checkFacet.appendChild(label);
            li.appendChild(checkFacet)
            ul.appendChild(li);
        }
        fContent.appendChild(ul);
        if (X.values.length > 10) {
            let facetFoot = document.createElement('div');
            facetFoot.classList.add('facet-content-footer');
            let facetButton = document.createElement('button');
            facetButton.classList.add('button-text-link', 'facet-button-more');
            facetButton.type = 'button';
            facetButton.setAttribute('form', 'FacetsFilterForm');
            facetButton.textContent = "+ Show More";
            facetFoot.appendChild(facetButton);
            fContent.appendChild(facetFoot);
        }
    }
    facet.appendChild(fContent)
    collapse.appendChild(facet);
    filterDiv.appendChild(collapse);
    return filterDiv;
}

function facetPrice(X, A) {
    let RangeField = document.createElement('div');
    RangeField.classList.add('facet-price-range-field');
    let Currency = document.createElement('span');
    Currency.classList.add('facet-price-range-currency');
    Currency.textContent = '$';
    RangeField.appendChild(Currency);
    let Input = document.createElement('input');
    Input.type = "number";
    Input.name = X;
    if (X == "filter.v.price.gte") {
        Input.id = "Price-from";
        Input.placeholder = "From";
    } else {
        Input.id = "Price-to";
        Input.placeholder = "To";
    }
    Input.min = "0";
    Input.max = "3259.00";
    if (A.filter(param => param[0] == X && param[1].length > 0).length > 0) {
        Input.setAttribute('value', `${A.filter(param => param[0] == X)[0][1]}`);
        if (A.filter(param => param[0] == 'filter.v.price.gte' && param[1].length > 0)) {
            let facetRemove = document.createElement('facet-remove');
            if (X == "filter.v.price.gte") {
                facetRemove.dataset.facet = `Price-from`;
            } else {
                facetRemove.dataset.facet = `Price-to`;
            }
            let facetTab = document.createElement('div');
            facetTab.classList.add('collection-filter-button', 'button', 'button-secondary');
            let facetName = document.createElement('span');
            if (X == "filter.v.price.gte") {
                facetName.textContent = `Min price: $${A.filter(param => param[0] == X && param[1].length > 0)[0][1]}`;
            } else {
                facetName.textContent = `Max price: $${A.filter(param => param[0] == X && param[1].length > 0)[0][1]}`;
            }
            facetTab.appendChild(facetName);
            let facetClose = document.createElement('span');
            facetClose.classList.add('collection-filter-dismiss');
            facetClose.textContent = '×';
            facetTab.appendChild(facetClose);
            facetRemove.appendChild(facetTab);
            document.querySelector('.collection-actions-filters').appendChild(facetRemove);
        }
    }
    Input.setAttribute('form', 'FacetsFilterForm');
    RangeField.appendChild(Input);
    return RangeField;
}

function productBuild(X, Y) {
    let varID = X.node.variants.edges[0].node.id;
    if (X.node.variants.edges.filter(variant => variant.node.availableForSale).length > 0) {
        varID = X.node.variants.edges.filter(variant => variant.node.availableForSale)[0].node.id;
    }
    li = document.createElement('li');
    li.classList.add('grid-item');
    let pc = document.createElement('product-card');
    pc.classList.add('card', 'card-product', 'card-product-no-rating', 'color-backgrond-2');
    let figure = document.createElement('figure');
    figure.classList.add('card-media');
    let link1 = document.createElement('a');
    link1.href = `https://${window.location.host}/products/${X.node.handle}?variant=${varID.replaceAll('gid://shopify/ProductVariant/', '')}${Y}`;
    let aspect = document.createElement('div');
    aspect.classList.add('aspect-ratio');
    aspect.style = "--ratio-percent: 100%;";
    for (i = 0; i < X.node.images.edges.length; i++) {
        let img = document.createElement('img');
        img.src = `${X.node.images.edges[i].node.url}&width=950`;
        if (X.node.images.edges[i].node.altText) {
            img.alt = X.node.images.edges[i].node.altText;
        }
        img.srcset = `${X.node.images.edges[i].node.url}&width=185 185w, ${X.node.images.edges[i].node.url}&width=200 200w, ${X.node.images.edges[i].node.url}&width=370 370w, ${X.node.images.edges[i].node.url}&width=420 420w, ${X.node.images.edges[i].node.url}&width=650 650w, ${X.node.images.edges[i].node.url}&width=750 750w, ${X.node.images.edges[i].node.url}&width=950 950w`;
        img.width = "950";
        img.height = "950";
        img.loading = "lazy";
        img.classList.add('card-media-image');
        img.sizes = "(min-width: 1200px) 420px, (min-width: 750px) calc((100vw - 4rem - 3rem) / 3), calc((100vw - 3rem - 1rem) / 2)";
        aspect.appendChild(img);
    }
    link1.appendChild(aspect)
    figure.appendChild(link1);
    pc.appendChild(figure);
    let wrap = document.createElement('div');
    wrap.classList.add('card-info-wrap');
    let info = document.createElement('div');
    info.classList.add('card-info');
    let eyebrow = document.createElement('div');
    eyebrow.classList.add('card-eyebrow');
    let vendorCollection = document.createElement('a');
    vendorCollection.href = `/collections/${X.node.vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`;
    vendorCollection.textContent = X.node.vendor;
    eyebrow.appendChild(vendorCollection);
    info.appendChild(eyebrow);
    let typog = document.createElement('h3');
    typog.classList.add('card-heading', 'typography-body');
    let prodName = document.createElement('a');
    prodName.title = X.node.title;
    prodName.href = `https://${window.location.host}/products/${X.node.handle}?variant=${varID.replaceAll('gid://shopify/ProductVariant/', '')}${Y}`;
    prodName.classList.add('js-product-link', 'new');
    prodName.textContent = X.node.title
    typog.appendChild(prodName);
    info.appendChild(typog);
    wrap.appendChild(info);
    let foot = document.createElement('div');
    foot.classList.add('card-footer');
    let price = document.createElement('div');
    price.classList.add('price');
    let pCont = document.createElement('div');
    pCont.classList.add('price-container');
    let pReg = document.createElement('div');
    pReg.classList.add('price-regular');
    let priceSpan = document.createElement('span');
    priceSpan.classList.add('price-item', 'price-item-regular', `VP-${X.node.variants.edges[0].node.price.amount * 100}`, `FP-${X.node.variants.edges[0].node.price.amount * 100}`);
    if (X.node.variants.edges.length > 1) {
        priceSpan.innerHTML = `<span class="sup">From</span>$${(Math.round(X.node.variants.edges[0].node.price.amount * 100) / 100).toFixed(2)}`;
    } else {
        priceSpan.textContent = `$${(Math.round(X.node.variants.edges[0].node.price.amount * 100) / 100).toFixed(2)}`;
    }
    pReg.appendChild(priceSpan)
    pCont.appendChild(pReg)
    price.appendChild(pCont);
    foot.appendChild(price)
    let stock = document.createElement('div');
    stock.id = "stockIcon";
    stock.classList.add('variantStock', 'plpStock');
    if (X.node.variants.edges.length <= X.node.variants.edges.filter(vars => !vars.node.availableForSale).length) {
        stock.classList.add('obscure');
    }
    stock.innerHTML = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280.000000 1253.000000" preserveAspectRatio="xMidYMid meet" class="availIcon"><g transform="translate(0.000000,1253.000000) scale(0.100000,-0.100000)" fill="#00ac00;" stroke="none"><path d="M12000 12520 c-192 -27 -395 -98 -655 -230 -446 -225 -961 -590
                -1620 -1149 -926 -785 -2158 -2000 -3466 -3416 -661 -717 -1389 -1537 -1913
                -2157 -87 -104 -159 -188 -160 -188 -1 0 -67 34 -146 76 -255 134 -875 442
                -1078 536 -849 391 -1441 595 -1912 659 -134 18 -368 13 -479 -10 -224 -48
                -405 -181 -495 -366 -52 -104 -69 -183 -70 -310 -1 -105 1 -113 32 -177 29
                -59 55 -87 235 -254 438 -407 919 -904 1273 -1315 792 -921 1625 -2167 2579
                -3858 168 -297 234 -355 405 -355 66 0 96 5 132 21 113 51 158 111 238 313
                135 341 398 964 565 1335 1285 2866 2820 5295 4654 7365 520 587 971 1049
                1821 1866 665 640 790 788 844 1005 81 328 -187 601 -604 614 -63 2 -144 0
                -180 -5z"></path></g></svg><span class="availabilityText textGreen">Available</span>`;
    foot.appendChild(stock);
    wrap.appendChild(foot);
    pc.appendChild(wrap);
    X.node.variants.edges[0].node.metafields = X.node.variants.edges[0].node.metafields.filter(meta => meta);
    if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value !== null && meta.value != '').length > 0) {
        let ribbon = document.createElement('div');
        ribbon.classList.add('ribbon');
        let ribText = document.createElement('span');
        ribText.classList.add('variant-metafield-secondary_text');
        ribText.textContent = X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text')[0].value;
        ribbon.appendChild(ribText);
        pc.appendChild(ribbon);
        if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.includes('Buy 3')).length > 0) {
            let primary = document.createElement('div');
            primary.classList.add('primary_promotion');
            let primarySpan = document.createElement('span');
            primarySpan.id = ('variant-metafield-primary_text');
            let primaryHead = document.createElement('h3');
            primaryHead.textContent = `SAVE $${(Math.floor((X.node.variants.edges[0].node.price.amount - 25) * 100) / 100)}`;
            primarySpan.appendChild(primaryHead);
            let primaryPara = document.createElement('p');
            primaryPara.textContent = `ON A SET OF 4`;
            primarySpan.appendChild(primaryPara);
            primary.appendChild(primarySpan)
            aspect.prepend(primary)
        } else if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.toLowerCase().includes('cash back')).length > 0) {
            let primary = document.createElement('div');
            primary.classList.add('primary_promotion');
            let primarySpan = document.createElement('span');
            primarySpan.id = ('variant-metafield-primary_text');
            let primaryHead = document.createElement('h3');
            let saving = X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.includes('Cash Back'))[0].value.split(' ')[0];
            if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.toLowerCase().includes('per unit')).length > 0) {
                saving = Number(saving.replaceAll('$', '')) * 4;
                saving = `$${saving}`;
            }
            primaryHead.textContent = `SAVE ${saving}`;
            primarySpan.appendChild(primaryHead);
            let primaryPara = document.createElement('p');
            primaryPara.textContent = `ON A SET OF 4`;
            primarySpan.appendChild(primaryPara);
            primary.appendChild(primarySpan)
            aspect.prepend(primary)
        } else if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.includes('%')).length > 0) {
            let primary = document.createElement('div');
            primary.classList.add('primary_promotion');
            let primarySpan = document.createElement('span');
            primarySpan.id = ('variant-metafield-primary_text');
            let primaryHead = document.createElement('h3');
            let percentage = Number(X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.includes('%'))[0].value.split('%')[0]);
            let saving = Math.floor((((Math.round((X.node.variants.edges[0].node.price.amount) * 100) / 100).toFixed(2) * 4) / 100) * percentage);
            primaryHead.textContent = `SAVE $${saving}`;
            primarySpan.appendChild(primaryHead);
            //if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'display' && meta.key == 'promotion_secondary_text' && meta.value.toLowerCase().includes('per unit')).length == 0) {
            let primaryPara = document.createElement('p');
            primaryPara.textContent = `ON A SET OF 4`;
            primarySpan.appendChild(primaryPara);
            //}
            primary.appendChild(primarySpan)
            aspect.prepend(primary)
        }
    }
    if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'storefront_icons' && meta.key == 'left').length > 0) {
        let badgeLeft = badges(X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'storefront_icons' && meta.key == 'left'), 'left');
        pc.appendChild(badgeLeft);
    }
    if (X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'storefront_icons' && meta.key == 'right').length > 0) {
        let badgeRight = badges(X.node.variants.edges[0].node.metafields.filter(meta => meta !== null && meta.namespace == 'storefront_icons' && meta.key == 'right'), 'right');
        pc.appendChild(badgeRight);
    }
    li.appendChild(pc);
    return li;
}

function badges(X, Y) {
    let badge = document.createElement('div');
    if (Y == 'left') {
        badge.classList.add('badgeLeft');
    } else {
        badge.classList.add('badgeRight');
    }
    let overlay = document.createElement('div');
    if (Y == 'left') {
        overlay.classList.add('badges-overlay-left');
    } else {
        overlay.classList.add('badges-overlay-right');
    }
    let icons = X;
    for (i = 0; i < icons.length; i++) {
        for (j = 0; j < icons[i].references.edges.length; j++) {
            let Wrap = document.createElement('div');
            Wrap.classList.add('promotion-placeholder-new', 'actual', `${j}`);
            let Image = document.createElement('img');
            Image.src = icons[i].references.edges[j].node.image.url;
            Image.width = "40";
            Image.height = "40";
            Wrap.appendChild(Image);
            let Break = document.createElement('br');
            Wrap.appendChild(Break);
            let Span = document.createElement('span');
            Span.textContent = icons[i].references.edges[j].node.image.altText;
            Wrap.appendChild(Span);
            overlay.appendChild(Wrap);
        }
    }
    badge.appendChild(overlay);
    return badge;
}

function infiniteScroll() {
    if (scrollY >= (document.body.scrollHeight - (document.documentElement.clientHeight * 4))) {
        document.removeEventListener('scroll', infiniteScroll)
        if (currentNext) {
            dualGrid();
        }
    }
}

function filterGrab() {
    const output = new Promise(function (resolve, reject) {
        let queryString = `{
	collection(handle:"promotions") {
        PageProd: products(first:1) {
            filters {
				id
				label
				values {
					id
					input
				}
			}
	        pageInfo {
		        hasNextPage
		        endCursor
	        }   
		}
	}
}`
        const opt = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': sFront
            },
            body: JSON.stringify({ query: queryString })
        };
        fetch(`https://${window.location.host}/api/2025-10/graphql.json`, opt)
            .then(response => response.json())
            .then(object => {
                let filters = object.data.collection.PageProd.filters.filter(filt => filt.label == "Promotions")
                promoFilters = filters;
                resolve(filters)
            })
    })
    return output;
}

dualGrid()